import {
    GET_NOTIFICATION_LIST,
    DELETE_NOTIFICATION,
    DELETE_ALL_NOTIFICATIONS,
    MARK_NOTIFICATIONS_AS_VIEWED,
    REPORT_ERROR,
} from './types';

import { BACKEND_API } from "../../config/middleware";
import API from "../../config/api-url";


export const getNotificationList = () => ({
    type: BACKEND_API,
    payload: Object.assign(
        {
            type: GET_NOTIFICATION_LIST,
            method: 'get',
            url: API.NOTIFICATION
        },
    )
});

export const deleteNotification = id => ({
    type: BACKEND_API,
    payload: Object.assign(
        {
            type: DELETE_NOTIFICATION,
            method: 'delete',
            url: `${API.NOTIFICATION}${id}`,
        },
    )
});

export const deleteAllNotifications = () => ({
    type: BACKEND_API,
    payload: Object.assign(
        {
            type: DELETE_ALL_NOTIFICATIONS,
            method: 'delete',
            url: API.NOTIFICATION,
        },
    )
});

export const markNotificationsAsViewed = data => ({
    type: BACKEND_API,
    payload: Object.assign(
        {
            type: MARK_NOTIFICATIONS_AS_VIEWED,
            method: 'post',
            url: `${API.NOTIFICATION}mark-notifications-as-viewed`,
            data: data
        },
    )
});

export const reportError = id => ({
    type: BACKEND_API,
    payload: Object.assign(
        {
            type: REPORT_ERROR,
            method: 'post',
            url: `${API.REPORT_ERROR}${id}`,
        },
    )
});